import React, { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Text from '../../atoms/Text';
import { PrimaryTextColoursByTheme, SecondaryTextColoursByTheme, ToolTipIconColoursByTheme } from './SubTotal.constants';
import styles from './SubTotal.module.scss';
import { usePresenter } from './SubTotal.presenter';
import type { SubTotalProps } from './SubTotal.types';
import { ToolTip } from '../../atoms/ToolTip';
import Icon from '../../atoms/Icon';

export const SubTotal: React.FC<SubTotalProps> = (props) => {
  const {
    formattedTotalCashPrice = '',
    formattedTotalLoyaltyPrice = '',
    loyaltyUnitName,
    serviceFeeText,
    isPayWithRewardsOnly,
    theme,
    shouldShowSubtotalTooltip,
  } = usePresenter(props);
  const { t } = useTranslation();

  const rightContent: ReactNode = (<>
    {!isPayWithRewardsOnly && (<>
      <Text
        size='Large'
        style='SemiBold'
        colour={PrimaryTextColoursByTheme[theme]}
        align='Right'
        value={formattedTotalCashPrice}
      />
      {
        formattedTotalLoyaltyPrice &&
        <Text
          size='Small'
          style='Regular'
          colour={SecondaryTextColoursByTheme[theme]}
          align='Right'
          value={t('subTotal.OR')}
        />
      }
    </>)}
    {
      formattedTotalLoyaltyPrice &&
      <div className={styles.loyaltyPrice}>
        <Text
          size='Large'
          style='SemiBold'
          colour={PrimaryTextColoursByTheme[theme]}
          align='Right'
          value={formattedTotalLoyaltyPrice}
        />
        {!!loyaltyUnitName && (
          <Text
            size='Small'
            style='Regular'
            colour={SecondaryTextColoursByTheme[theme]}
            align='Right'
            value={loyaltyUnitName}
          />
        )}
      </div>
    }
  </>);

  return (
    <div className={styles.subTotalContainer}>
      <div className={styles.subTotal}>
        <Text
          type='Subheading'
          size='Medium'
          style='SemiBold'
          colour={PrimaryTextColoursByTheme[theme]}
          value={t('subTotal.title')}
        />
        <div className={styles.rightContent}>
          {rightContent}
        </div>
      </div>
      {!!serviceFeeText && (
        <div className={styles.serviceFeeContainer}>
          <Text
            size='Small'
            style='Regular'
            colour={SecondaryTextColoursByTheme[theme]}
            align='Right'
            value={serviceFeeText}
            className={styles.serviceFeeText}
          />
          {shouldShowSubtotalTooltip && (
            <ToolTip
              className={styles.priceTooltip}
              textKey='subTotal.tooltipInfo'
              theme={theme}
              ariaLabelKey=''
              placement={'top'}
            >
              <Icon
                asset='InfoFilled'
                style={ToolTipIconColoursByTheme[theme]}
              />
            </ToolTip>)
          }
        </div>)
      }
    </div>
  );
};
